export const API_BASE_PATH = '/api/v1';

export const defaultAppData = {
  googleAnalyticsId: 'UA-103831275-1',
  user: {
    id: 0,
    rootBusinessUnit: { id: 0 },
    currentBusinessUnit: { id: 0 },
    isAdmin: false,
  },
  localizationInfo: { Locale: 'en-US' },
};

export const EventId = 'FEATURE_OCE_EVENTS_GENERAL';
export const ConsentId = '00000000000000000000000000000001';
export const HCO = 'HCO';
export const HCP = 'HCP';



// WEBPACK FOOTER //
// ./src/Shared/constants.js